import { gql } from '@apollo/client';

export const PAIR_DEVICE = gql`
  mutation PairDevice($input: PairDeviceReqInput!) {
    pairDevice(input: $input) {
      id
      name
      isPaired
      config {
        ... on OrbDeviceConfig {
          orderTypeIds
          printerProfileIds
          autoClearTimeout
          theme {
            dark
          }
        }
      }
      deviceMetadata {
        platform
        appVersion
        browser
        deviceType
        os
        screenResolution
        timezone
        userAgent
      }
    }
  }
`;

export const GET_DEVICE_CONFIG = gql`
  query getDeviceConfig($id: ID!) {
    device(id: $id) {
      id
      config {
        ... on OrbDeviceConfig {
          orderTypeIds
          printerProfileIds
          autoClearTimeout
          theme {
            dark
          }
        }
      }
    }
    salesChannels {
      id
      name
    }
  }
`;

export const DEVICE_EVENTS = gql`
  subscription DeviceEvents($storeId: String!, $deviceId: String!) {
    deviceEvents(storeId: $storeId, deviceId: $deviceId) {
      deviceId
      storeId
      organizationId
      action
      uuid
    }
  }
`;

export const UNPAIR_DEVICE = gql`
  mutation UnpairDevice($deviceId: ID!) {
    unpairDevice(deviceId: $deviceId)
  }
`;

export const UPDATE_DEVICE = gql`
  mutation UpdateDevice($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      id
      appVersion
    }
  }
`;

export const GET_DEVICES = gql`
  query GetDevices($filters: GetDevicesFiltersInput) {
    devices(filters: $filters) {
      id
      name
      mode
      isPaired
      uuid
      config {
        ... on OrbDeviceConfig {
          orderTypeIds
          printerProfileIds
        }
      }
    }
  }
`;
